module.exports = __webpack_public_path__ + "static/training-room-mobile-26d5f8dd4eba60c1c55252363160b8f5.jpg";